/* eslint-disable no-console */
module.exports = {
  debug: console.debug,
  error: console.error,
  info: console.log,
  console: console.log,
  trace: console.log,
  warn: console.warn,
};
